<template>
  <div class="mainDiv">
    <img
      :src="
        $common._getTerminalMsg().isMobile
          ? require('./img/empty_3.png')
          : require('./img/empty_1.png')
      "
      alt=""
      :class="$common._getTerminalMsg().isMobile ? 'imgMobile' : ''"
    />
    <div :class="$common._getTerminalMsg().isMobile ? 'textMobile' : 'textPc'">
      {{ text }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "暂无数据~"
    }
  },
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.mainDiv {
  // height: 100%;
  // width: 100%;
  // overflow: auto;
  // background-color: #f4f5f6;
  text-align: center;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-flow: column;
  & > .imgMobile {
    width: 200px;
  }
  & > .textMobile {
    color: #999;
    font-size: 16px;
  }
  & > .textPc {
    color: #999;
    font-size: 17px;
  }
}
</style>
